import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CustomerCategory, CustomerSegment, GTM } from '../../../../../models'
import { ConvertResponseForSelect } from '../../../../../components/helper/commonfunctions'
import { DataStore, Predicates, SortDirection } from "@aws-amplify/datastore";
import capitalizeFirst from "../../../../../components/common/capitalizeFirst";
import { ValidateHRRole } from "../../../../../components/helper/validateRole";
import LeftSideBar from '../../../../../components/common/hr/leftnav.component';
import TopNavBar from '../../../../../components/common/hr/topnav.component';
import HRLogin from '../../../../../setup/auth/hr.component';
import Select from 'react-select'
import { graphQLGetAllData, graphQLFindRecordById } from '../../../../../components/helper/graphQLFunctions';
import * as mutations from '../../../../../graphql/mutations';
import * as queries from '../../../../../graphql/queries';
import { API, graphqlOperation } from 'aws-amplify';

export default function CreateCustomerCategory() {

    const { editCustomerCategoryId } = useParams();
    let navigateTo = useNavigate();

    //Validate User Logged In
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [showPleaseWaitButton, setPleaseWaitButton] = useState(false);
    const [isEditMode, setEditMode] = useState(false);
    const [customerCategoryId, setCustomerCategoryId] = useState("");

    //Save Fields
    const [customerCategoryList, setCustomerCategoryList] = useState("");
    const [refCode, SetRefCode] = useState("");

    //List
    const [customerSegmentList, setCustomerSegmentList] = useState([]);
    const [customerSegment, setCustomerSegment] = useState("");
    const [customerSegmentId, setCustomerSegmentId] = useState("");
    //GTM
    const [GtmList, setGTMList] = useState([]);
    const [gtmVal, setGtm] = useState("");
    const [gtmId, setGtmId] = useState("");

    // Create Record
    const saveCustomerCategory = async () => {
        if (customerCategoryList === "") { toast.error("Please enter Group."); return; }
        if (customerSegmentId === "") { toast.error("Please select Segment."); return; }

        setPleaseWaitButton(true);

        if (isEditMode) {
            // const original = await DataStore.query(CustomerCategory, customerCategoryId);
            const original = await graphQLFindRecordById('getCustomerCategory', customerCategoryId);

            // await DataStore.save(
            //     CustomerCategory.copyOf(original, (updated) => {
            //         updated.name = capitalizeFirst(customerCategoryList);
            //         updated.REF_CODE = capitalizeFirst(refCode);
            //         updated.customer_segment_id = customerSegmentId;
            //         updated.gtm_i = gtmId;
            //     })
            // );

            await API.graphql({
                query: mutations.updateCustomerCategory,
                variables: {
                    input: {
                        id: original.id,
                        name: capitalizeFirst(customerCategoryList),
                        REF_CODE: capitalizeFirst(refCode),
                        customer_segment_id: customerSegmentId,
                        gtm_i: gtmId,
                        _version: original._version,
                    }
                }
            });
            toast.success("Updated");
        } else {
            // await DataStore.save(new CustomerCategory({ 
            //     name: capitalizeFirst(customerCategoryList), 
            //     gtm_i: gtmId, 
            //     customer_segment_id: customerSegmentId, 
            //     REF_CODE: capitalizeFirst(refCode) 
            // }));

            await API.graphql(
                graphqlOperation(mutations.createCustomerCategory, {
                    input: {
                        name: capitalizeFirst(customerCategoryList),
                        gtm_i: gtmId,
                        customer_segment_id: customerSegmentId,
                        REF_CODE: capitalizeFirst(refCode)
                    }
                })
            );
            toast.success("Added");
        }

        setPleaseWaitButton(false);
        navigateTo("/hr/setting/dimensions/customercategory");
    };

    async function BindList() {
        // var customersSegmentList = await DataStore.query(CustomerSegment, Predicates.ALL, {
        //     sort: s => s.name(SortDirection.ASCENDING)
        // });

        var customersSegmentList = await graphQLGetAllData('listCustomerSegments');
        customersSegmentList = customersSegmentList.sort((a,b)=>a.name.localeCompare(b.name));
        var returnArray = []; returnArray = ConvertResponseForSelect(customersSegmentList); setCustomerSegmentList(returnArray);

        // var gtmArrayList = await DataStore.query(GTM, Predicates.ALL, {
        //     sort: s => s.name(SortDirection.ASCENDING)
        // });

        var gtmArrayList = await graphQLGetAllData('listGTMS');
        gtmArrayList = gtmArrayList.sort((a,b)=>a.name.localeCompare(b.name));

        var returnGTMArray = []; returnGTMArray = ConvertResponseForSelect(gtmArrayList); setGTMList(returnGTMArray);
        console.log('gtmArrayList' + JSON.stringify(returnGTMArray))

    }

    async function onLoad() {
        try {
            if (!ValidateHRRole()) { userHasAuthenticated(false); }

            await BindList();
            //Edit existing record
            if (editCustomerCategoryId != null) {
                setCustomerCategoryId(editCustomerCategoryId);

                // const original = await DataStore.query(CustomerCategory, editCustomerCategoryId);
                const original = await graphQLFindRecordById('getCustomerCategory', editCustomerCategoryId);

                if (original != null) {

                    // const Segment_original = await DataStore.query(CustomerSegment, original.customer_segment_id);

                    const Segment_original = await graphQLFindRecordById('getCustomerSegment',  original.customer_segment_id);

                    setCustomerSegment({ label: Segment_original.name + " (" + Segment_original.REF_CODE + ")", value: Segment_original.id });
                    setCustomerSegmentId(Segment_original.id)

                    // const Gtm_original = await DataStore.query(GTM, original.gtm_i);
                    const Gtm_original = await graphQLFindRecordById('getGTM', original.gtm_i);

                    if (original.gtm_i) {
                        setGtm({ label: Gtm_original.name + " (" + Gtm_original.REF_CODE + ")", value: Gtm_original.id });
                        setGtmId(Gtm_original.id)
                    }

                    setCustomerCategoryList(original.name);
                    SetRefCode(original.REF_CODE);
                    setEditMode(true);
                }
                else {
                    toast.error('Invalid record.');
                    navigateTo("/hr/setting/dimensions/customercategory");
                }

            }
        } catch (e) {
            userHasAuthenticated(false);
        }
    }

    useEffect(() => {
        onLoad();
    }, []);

    return (
        isAuthenticated ? (
            <div>
                <div className="pt-16 xl:h-full lg:h-full md:h-full 2xl:h-full">
                    <TopNavBar />
                    <LeftSideBar />

                    <div className="pl-16">
                        <div className="flex grid flex-row flex-wrap justify-center flex-1 gap-4 p-5 pl-5 pr-5 mt-5 align-center 2xl:grid-cols-8 xl:grid-cols-10 lg:grid-cols-8 md:grid-cols-8 sm:grid-cols-1 contract-grid-wrapper">
                            <div className="col-span-6 col-start-3 lg:col-start-3 xl:col-start-3 2xl:col-start-2">
                                <div className="p-3 py-5 bg-white rounded-md shadow dark:bg-[#252423]">
                                    <div className="flex justify-center mt-3 mb-2">
                                        <h2 className="page-title">
                                            {isEditMode ? "Edit" : "Create"} Customer Group
                                        </h2>
                                    </div>
                                    <div x-data="{tab: 1}"></div>
                                    <div className={"block w-full"}>
                                        <div className="px-4" x-show="tab === 1">
                                            <div className="flex grid flex-row flex-wrap flex-1 mb-6 align-center 2xl:grid-cols-2 xl:grid-cols-2 lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 gap-x-4">
                                                <div className="relative mb-4">
                                                    <label
                                                        htmlFor=""
                                                        className="text-[#344054] text-[14px] font-medium dark:text-[#FFFFFF]"
                                                    >
                                                        Customer Group
                                                        <label
                                                            htmlFor=""
                                                            className="text-[#FF0000] text-[14px] font-medium"
                                                        >
                                                            *{" "}
                                                        </label>
                                                    </label>
                                                    <input
                                                        value={(customerCategoryList)}
                                                        onChange={(e) => setCustomerCategoryList(e.target.value)}
                                                        type="text"
                                                        id=""
                                                        className="text-[16px] rounded-lg  flex-1  border border-[#D0D5DD] w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-500 shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 mt-1.5 placeholder:text-[#667085] dark:bg-[#333231] dark:border-[#333231] dark:text-[#FFFFFF]"
                                                        placeholder="Enter Customer Group"
                                                    />

                                                </div>
                                                <div className="relative mb-4">
                                                    <label
                                                        htmlFor=""
                                                        className="text-[#344054] text-[14px] font-medium dark:text-[#FFFFFF]"
                                                    >
                                                        Ref_Code
                                                        <label
                                                            htmlFor=""
                                                            className="text-[#FF0000] text-[14px] font-medium"
                                                        >

                                                        </label>
                                                    </label>
                                                    <input
                                                        value={(refCode)}
                                                        onChange={(e) => SetRefCode(e.target.value)}
                                                        type="text"
                                                        id=""
                                                        className="text-[16px] rounded-lg  flex-1  border border-[#D0D5DD] w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-500 shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 mt-1.5 placeholder:text-[#667085] dark:bg-[#333231] dark:border-[#333231] dark:text-[#FFFFFF]"
                                                        placeholder="Ref Code"
                                                    />
                                                </div>

                                                <div className="relative mb-4">
                                                    <label
                                                        htmlFor=""
                                                        className="text-[#344054] text-[14px] font-medium dark:text-[#FFFFFF]"
                                                    >
                                                        Customer Segment
                                                        <label
                                                            htmlFor=""
                                                            className="text-[#FF0000] text-[14px] font-medium"
                                                        >
                                                            *{" "}
                                                        </label>
                                                    </label>
                                                    <Select placeholder='Select' options={customerSegmentList} value={customerSegment} onChange={e => {
                                                        setCustomerSegment(e)
                                                        setCustomerSegmentId(e.value)
                                                    }} className="mt-2 my-react-select-container"
                                                        classNamePrefix="my-react-select" />
                                                </div>
                                                <div className="relative mb-4">
                                                    <label
                                                        htmlFor=""
                                                        className="text-[#344054] text-[14px] font-medium dark:text-[#FFFFFF]"
                                                    >
                                                        GTM
                                                        <label
                                                            htmlFor=""
                                                            className="text-[#FF0000] text-[14px] font-medium"
                                                        >
                                                            {" "}
                                                        </label>
                                                    </label>
                                                    <Select placeholder='Select' options={GtmList} value={gtmVal} onChange={e => {
                                                        setGtm(e)
                                                        setGtmId(e.value)
                                                    }} className="mt-2 my-react-select-container"
                                                        classNamePrefix="my-react-select" />
                                                </div>
                                            </div>
                                            <div className="grow flex justify-center gap-3 mb-3">
                                                <Link
                                                    to="/hr/setting/dimensions/customercategory"
                                                    className=" py-2 px-5 bg-white text-[#344054] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:border-[#4A5056] dark:bg-[#4A5056] dark:text-white"
                                                >
                                                    Cancel
                                                </Link>
                                                <button
                                                    onClick={() => saveCustomerCategory()}
                                                    className=" py-2 px-6 bg-btn-blue text-[#fff] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md"
                                                >
                                                    {showPleaseWaitButton ? "Please wait..." : "Submit"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <HRLogin sessionExpired={1} />
        )

    );
}
